<template>
    <TimeFieldRoot
        v-slot="{ segments }"
        :class="rootClass"
        :disabled="disabled"
        :granularity="granularity"
        :hour-cycle="hourCycle"
        :model-value="timeValue"
        @update:model-value="handleUpdate"
    >
        <template v-for="segment in segments" :key="segment.part">
            <TimeFieldInput v-if="segment.part === 'literal'" :part="segment.part" class="text-muted-foreground px-0">
                {{ segment.value }}
            </TimeFieldInput>
            <TimeFieldInput v-else :part="segment.part" :class="inputClass">
                {{ segment.value }}
            </TimeFieldInput>
        </template>
    </TimeFieldRoot>
</template>
<script setup>
import { computed } from 'vue';
import { parseTime } from '@internationalized/date';
import { TimeFieldInput, TimeFieldRoot } from 'reka-ui';

const props = defineProps({
    // 24h "HH:mm" string or null; `hourCycle` is display-only.
    modelValue: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    granularity: { type: String, default: 'minute' },
    hourCycle: { type: Number, default: 24 },
    rootClass: { type: String, default: 'flex items-center gap-0.5 font-medium tabular-nums' },
    inputClass: {
        type: String,
        default:
            'data-[placeholder]:text-muted-foreground inline-flex items-center justify-center rounded-sm px-0.5 tabular-nums caret-transparent outline-none focus:bg-accent focus:text-white',
    },
});

const emit = defineEmits(['update:modelValue']);

// Malformed input throws in parseTime → treat as null so the component renders empty.
const timeValue = computed(() => {
    if (typeof props.modelValue !== 'string') return null;
    try {
        return parseTime(props.modelValue);
    } catch {
        return null;
    }
});

const handleUpdate = (time) => {
    if (!time) {
        emit('update:modelValue', null);
        return;
    }
    const hh = String(time.hour).padStart(2, '0');
    const mm = String(time.minute).padStart(2, '0');
    emit('update:modelValue', `${hh}:${mm}`);
};
</script>
